module.exports = __webpack_public_path__ + "img/messages-with-alert-white.8417fc26.svg";